import {AfterViewInit, Component, Injectable, Input, ViewChild} from '@angular/core';
import {GmapMarker} from '../shared/models';
import {AgmMap} from '@agm/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class AgmHelperService {
  mapLoadStatus: BehaviorSubject<boolean>;
  mapReady: Observable<boolean>;
  mapReadyPromise: Promise<boolean>;

  constructor() {
    this.initializeValues();
  }

  initializeValues(): void {
    this.mapLoadStatus = new BehaviorSubject<boolean>(false);
    this.mapReady = this.mapLoadStatus.asObservable();
    this.mapReadyPromise = this.mapLoadStatus.toPromise();
  }

  updateMapLoadStatus(mapReady: boolean) {
    this.mapLoadStatus.next(mapReady);
    this.mapLoadStatus.complete();
    this.initializeValues();
  }
}

@Component({
  selector: 'app-zipcode-map',
  templateUrl: './zipcode-map.component.html',
  styleUrls: ['./zipcode-map.component.scss'],
})
export class ZipcodeMapComponent implements AfterViewInit {

  @ViewChild('AgmMap') agmMap: AgmMap;
  @Input() mapData: GmapMarker[];
  @Input() fromPdf: boolean;
  selectedMarker: GmapMarker;
  previous: any;

  constructor(private agmHelper: AgmHelperService) {
  }

  clickedMarker(data: GmapMarker, infoWindow: any) {
    if (this.previous) {
      this.previous.close();
    }
    this.previous = infoWindow;
    this.selectedMarker = data;
  }

  ngAfterViewInit(): void {
    this.agmMap.tilesLoaded.subscribe(() => {
      if (this.fromPdf) {
        this.agmHelper.updateMapLoadStatus(true);
      }
    });
  }
}
